import { render, staticRenderFns } from "./HighValueBadge.vue?vue&type=template&id=28e0d2d9&scoped=true"
import script from "./HighValueBadge.vue?vue&type=script&lang=js"
export * from "./HighValueBadge.vue?vue&type=script&lang=js"
import style0 from "./HighValueBadge.vue?vue&type=style&index=0&id=28e0d2d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0d2d9",
  null
  
)

export default component.exports